import { render } from "./TextContent.vue?vue&type=template&id=3a7b4335&scoped=true"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"

import "./TextContent.vue?vue&type=style&index=0&id=3a7b4335&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7b4335"]])

export default __exports__